import * as Types from '../../../../graphql-types'

import { gql } from '@apollo/client'
import { ContentDetails_Tag_ContentReferenceFragmentFragmentDoc } from '../../../../services/yi/queries/ContentDetailsTagContentReferenceFragment.generated'
import { Content_ProviderMetadataFragmentFragmentDoc } from '../../../../services/yi/queries/ContentProviderMetadataFragment.generated'
import { Content_ProviderCommonFragmentFragmentDoc } from '../../../../services/yi/queries/ContentProviderCommonFragment.generated'
import { ContentDetails_Person_ContentReferenceFragmentFragmentDoc } from '../../../../services/yi/queries/ContentDetailsPersonContentReferenceFragment.generated'
export type YiCourse_ModuleDetailsContentFragmentFragment = {
  __typename?: 'Content'
  title?: string | null
  id?: string | null
  contentType?: string | null
  contentId?: number | null
  published?: boolean | null
  yiCourseModuleType?: Array<{
    __typename?: 'ContentReference'
    id?: string | null
    sortKey?: number | null
    contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
    contentTo?: Array<{
      __typename?: 'Content'
      id?: string | null
      titleGroupId?: string | null
      title?: string | null
      contentId?: number | null
      contentType?: string | null
      published?: boolean | null
    } | null> | null
  } | null> | null
  providerMetadata?: {
    __typename?: 'ContentProvider'
    metadata?: any | null
    contentId?: string | null
  } | null
}

export type YiCourse_ModulesContentReferenceFragmentFragment = {
  __typename?: 'ContentReference'
  sortKey?: number | null
  id?: string | null
  contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
  contentTo?: Array<{
    __typename?: 'Content'
    title?: string | null
    id?: string | null
    contentType?: string | null
    contentId?: number | null
    published?: boolean | null
    yiCourseModuleType?: Array<{
      __typename?: 'ContentReference'
      id?: string | null
      sortKey?: number | null
      contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
      contentTo?: Array<{
        __typename?: 'Content'
        id?: string | null
        titleGroupId?: string | null
        title?: string | null
        contentId?: number | null
        contentType?: string | null
        published?: boolean | null
      } | null> | null
    } | null> | null
    providerMetadata?: {
      __typename?: 'ContentProvider'
      metadata?: any | null
      contentId?: string | null
    } | null
  } | null> | null
}

export type YiCourse_ContentFragmentFragment = {
  __typename?: 'Content'
  id?: string | null
  contentId?: number | null
  contentType?: string | null
  published?: boolean | null
  publishedAtDate?: any | null
  createdAt?: any | null
  updatedAt?: any | null
  title?: string | null
  path?: string | null
  shortDescription?: string | null
  description?: string | null
  language?: string | null
  seoDescription?: string | null
  seoTitle?: string | null
  descriptionFormat?: string | null
  shortDescriptionFormat?: string | null
  displayType?: string | null
  featureMediaId?: string | null
  primaryLanguage?: string | null
  productType?: string | null
  contentProvider?: {
    __typename?: 'ContentProvider'
    provider?: Types.ContentProviderProviders | null
    providerKey?: string | null
    contentId?: string | null
  } | null
  contentPolicy?: {
    __typename?: 'ContentPolicy'
    policyId?: string | null
    name?: string | null
  } | null
  yiContentType?: Array<{
    __typename?: 'ContentReference'
    id?: string | null
    sortKey?: number | null
    contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
    contentTo?: Array<{
      __typename?: 'Content'
      id?: string | null
      titleGroupId?: string | null
      title?: string | null
      contentId?: number | null
      contentType?: string | null
      published?: boolean | null
    } | null> | null
  } | null> | null
  yiTags?: Array<{
    __typename?: 'ContentReference'
    id?: string | null
    sortKey?: number | null
    contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
    contentTo?: Array<{
      __typename?: 'Content'
      id?: string | null
      titleGroupId?: string | null
      title?: string | null
      contentId?: number | null
      contentType?: string | null
      published?: boolean | null
    } | null> | null
  } | null> | null
  yiYogaTeacher?: Array<{
    __typename?: 'ContentReference'
    id?: string | null
    sortKey?: number | null
    contentReferenceType?: {
      __typename?: 'ContentReferenceType'
      id?: string | null
      type?: string | null
    } | null
    contentTo?: Array<{
      __typename?: 'Content'
      id?: string | null
      title?: string | null
      language?: string | null
      contentType?: string | null
      contentId?: number | null
      published?: boolean | null
      avatar?: Array<{
        __typename?: 'ImageContentRelationship'
        id?: string | null
        type?: string | null
        image?: { __typename?: 'Image'; id?: string | null; url?: string | null } | null
      } | null> | null
    } | null> | null
  } | null> | null
  yiActionType?: Array<{
    __typename?: 'ContentReference'
    id?: string | null
    sortKey?: number | null
    contentReferenceType?: {
      __typename?: 'ContentReferenceType'
      id?: string | null
      type?: string | null
    } | null
    contentTo?: Array<{
      __typename?: 'Content'
      id?: string | null
      title?: string | null
      language?: string | null
      contentType?: string | null
      contentId?: number | null
      published?: boolean | null
      avatar?: Array<{
        __typename?: 'ImageContentRelationship'
        id?: string | null
        type?: string | null
        image?: { __typename?: 'Image'; id?: string | null; url?: string | null } | null
      } | null> | null
    } | null> | null
  } | null> | null
  yiCourseModules?: Array<{
    __typename?: 'ContentReference'
    sortKey?: number | null
    id?: string | null
    contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
    contentTo?: Array<{
      __typename?: 'Content'
      title?: string | null
      id?: string | null
      contentType?: string | null
      contentId?: number | null
      published?: boolean | null
      yiCourseModuleType?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        sortKey?: number | null
        contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
        contentTo?: Array<{
          __typename?: 'Content'
          id?: string | null
          titleGroupId?: string | null
          title?: string | null
          contentId?: number | null
          contentType?: string | null
          published?: boolean | null
        } | null> | null
      } | null> | null
      providerMetadata?: {
        __typename?: 'ContentProvider'
        metadata?: any | null
        contentId?: string | null
      } | null
    } | null> | null
  } | null> | null
  yiCourseSalesPages?: Array<{
    __typename?: 'ContentReference'
    id?: string | null
    contentFrom?: Array<{
      __typename?: 'Content'
      id?: string | null
      contentType?: string | null
      contentId?: number | null
      title?: string | null
      published?: boolean | null
    } | null> | null
  } | null> | null
  providerMetadata?: {
    __typename?: 'ContentProvider'
    metadata?: any | null
    contentId?: string | null
  } | null
}

export const YiCourse_ModuleDetailsContentFragmentFragmentDoc = gql`
  fragment YICourse_ModuleDetailsContentFragment on Content {
    title
    id
    contentType
    contentId
    published
    yiCourseModuleType: contentReferencesFrom(types: "yi-course-module-type") {
      ...ContentDetails_Tag_ContentReferenceFragment
    }
    ...Content_ProviderMetadataFragment
  }
  ${ContentDetails_Tag_ContentReferenceFragmentFragmentDoc}
  ${Content_ProviderMetadataFragmentFragmentDoc}
`
export const YiCourse_ModulesContentReferenceFragmentFragmentDoc = gql`
  fragment YICourse_ModulesContentReferenceFragment on ContentReference {
    sortKey
    id
    contentReferenceType {
      type
    }
    contentTo {
      ...YICourse_ModuleDetailsContentFragment
    }
  }
  ${YiCourse_ModuleDetailsContentFragmentFragmentDoc}
`
export const YiCourse_ContentFragmentFragmentDoc = gql`
  fragment YICourse_ContentFragment on Content {
    id
    contentId
    contentType
    published
    publishedAtDate
    createdAt
    updatedAt
    title
    path
    shortDescription
    description
    language
    seoDescription
    seoTitle
    contentProvider {
      provider
      providerKey
      ...Content_ProviderCommonFragment
    }
    contentPolicy {
      policyId
      name
    }
    descriptionFormat
    shortDescriptionFormat
    displayType
    featureMediaId
    primaryLanguage
    productType
    seoDescription
    seoTitle
    yiContentType: contentReferencesFrom(types: "yi-content-type") {
      ...ContentDetails_Tag_ContentReferenceFragment
    }
    yiTags: contentReferencesFrom(types: "yi-tag") {
      ...ContentDetails_Tag_ContentReferenceFragment
    }
    yiYogaTeacher: contentReferencesFrom(types: "yi-yoga-teacher") {
      ...ContentDetails_Person_ContentReferenceFragment
    }
    yiActionType: references(types: "yi-action-type") {
      ...ContentDetails_Person_ContentReferenceFragment
    }
    yiCourseModules: contentReferencesFrom(types: ["yi-course-module", "yi-course-module-group"]) {
      ...YICourse_ModulesContentReferenceFragment
    }
    yiCourseSalesPages: contentReferencesTo(types: "yi-course") {
      id
      contentFrom {
        id
        contentType
        contentId
        title
        published
      }
    }
    ...Content_ProviderMetadataFragment
  }
  ${Content_ProviderCommonFragmentFragmentDoc}
  ${ContentDetails_Tag_ContentReferenceFragmentFragmentDoc}
  ${ContentDetails_Person_ContentReferenceFragmentFragmentDoc}
  ${YiCourse_ModulesContentReferenceFragmentFragmentDoc}
  ${Content_ProviderMetadataFragmentFragmentDoc}
`
